import React from "react";
import { bind } from "decko";

export default class TimeCode extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            videoCurrentTime: 0
        };
    }

    componentDidMount () {
        this.updateInterval = setInterval(this.tick, 100);
    }

    componentWillUnmount () {
        clearInterval(this.updateInterval);
    }

    @bind
    tick () {
        if (!this.props.video){
            return;
        }
        let currentTime = this.props.video.currentTime;
        if (currentTime) {
            this.setState({
                videoCurrentTime: currentTime
            });
        }
    }

    padNumber (num, length) {
        return num.toString().padStart(length, "0")
    }

    render () {
        let seconds = this.state.videoCurrentTime;
        let timestamp = new Date(this.props.streamRecordingTime);
        timestamp.setMilliseconds(timestamp.getMilliseconds() + (seconds * 1000));

        let style = this.props.style || {};
        return (
            <div style={style}>
                <div className="transparent-black-bg" style={{
                    padding: "3px",
                    borderRadius: "6px",
                    fontSize: "10px",
                }}>
                    <div className="text-outline text-center">
                        {this.padNumber(timestamp.getHours(), 2)}:
                        {this.padNumber(timestamp.getMinutes(), 2)}:
                        {this.padNumber(timestamp.getSeconds(), 2)}.
                        {this.padNumber(timestamp.getMilliseconds(), 3)}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/TimeCode.js